import { createRequestTypes } from '../utils';

export const UPLOAD_COMPANY_ORDER_DOCUMENT = createRequestTypes('companyOrderDocument/UPLOAD_COMPANY_ORDER_DOCUMENT');
